var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.031,22.792V22.78v-7.988h63.938v7.988v0.012H16.031z M16.027,14.788c-2.141,0-4.148,0.832-5.66,2.348 c-1.512,1.512-2.34,3.523-2.336,5.66l8-0.016L16.027,14.788z M85.633,17.136c-1.512-1.516-3.52-2.348-5.66-2.348l-0.004,7.992 l8,0.016C87.973,20.659,87.145,18.647,85.633,17.136z M43.975,8.82h8.049v-8h-8.049v7.614l-0.004-7.618 c-2.141,0-4.148,0.832-5.66,2.348c-1.512,1.512-2.34,3.523-2.336,5.66C35.975,8.824,43.975,8.808,43.975,8.82z M57.689,3.164 c-1.512-1.516-3.52-2.348-5.66-2.348l-0.004,7.992l8,0.016C60.029,6.687,59.201,4.675,57.689,3.164z M66.103,85.9h-36.91 l-7.977-57.057l-8.283-0.02l8.412,60.197c0.42,2.896,2.943,5.079,5.868,5.079h40.869c2.925,0,5.447-2.184,5.871-5.1l8.409-60.176 l-8.282,0.02L66.103,85.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.75f0921451f08654b6115562f2a5b402.svg";
export { ForwardRef as ReactComponent };